// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__23_lS","colMaxWidth":"Table_colMaxWidth__3Oy8S"};